<!--
 * @ Author: Lmi
 * @ Create Time: 2023-09-05 15:00:55
 * @ Modified by: Your name
 * @ Modified time: 2023-09-05 15:00:55
 * @ Description: 数据统计>平台统计>用户月充电信息统计 
 -->

<template>
  <scroll-layout>
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div class="user-monthly-charging-statistics">
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns">
        <template #headerButtons>
          <div class="table-header-button">
            <template v-for="(btn, i) in pageButtons">
              <ykc-button :type="btn.type" v-if="btn.enabled()" :key="i" @click="btn.handleClick">
                {{ btn.text }}
              </ykc-button>
            </template>
          </div>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>

<script>
  import { offlineExport, code, localGetItem } from '@/utils';
  import { dataStatisticsServe } from '@/service/apis';

  export default {
    name: 'userMonthlyChargingStatisticsList',

    data() {
      return {
        pageButtons: [
          {
            id: '0',
            text: '导出',
            type: 'plain',
            enabled: () => code('user:monthly:charge:export'),
            handleClick: () => {
              this.doExportFile();
            },
          },
        ],
        tableData: [],
        tableColumns: [
          { label: '用户账号', prop: 'account', minWidth: '180px' },
          { label: '用户id', prop: 'uid', minWidth: '150px' },
          { label: '1月', prop: 'january', minWidth: '120px' },
          { label: '2月', prop: 'february', minWidth: '120px' },
          { label: '3月', prop: 'march', minWidth: '120px' },
          { label: '4月', prop: 'april', minWidth: '120px' },
          { label: '5月', prop: 'may', minWidth: '120px' },
          { label: '6月', prop: 'june', minWidth: '120px' },
          { label: '7月', prop: 'july', minWidth: '120px' },
          { label: '8月', prop: 'august', minWidth: '120px' },
          { label: '9月', prop: 'september', minWidth: '120px' },
          { label: '10月', prop: 'october', minWidth: '120px' },
          { label: '11月', prop: 'november', minWidth: '120px' },
          { label: '12月', prop: 'december', minWidth: '120px' },
        ],
        tableTitle: '明细列表',
        pageInfo: {
          current: 1,
          size: 10,
        },
        dictionary: {},
        searchParams: {
          queryDate: '',
          account: '',
          uid: '',
          type: 'ELECTRICAL',
        },
      };
    },
    created() {
      const date = new Date();
      this.searchParams.queryDate = `${date.getFullYear()}`; // 默认当前年份
      console.log('---queryDate', this.searchParams.queryDate);

      const dictionary = localGetItem('dictionary');
      if (dictionary?.user_filter_type) {
        this.dictionary = dictionary.user_filter_type.map(item => ({
          id: item.code,
          name: item.name,
        }));
      }

      this.searchTableList();
    },
    computed: {
      searchData() {
        return [
          {
            label: '时间维度',
            key: 'queryDate',
            comName: 'YkcDatePicker',
            format: 'yyyy',
            type: 'year',
          },
          {
            comName: 'YkcInput',
            key: 'account',
            label: '账号',
            placeholder: '请输入账号',
          },
          {
            comName: 'YkcInput',
            key: 'uid',
            label: '用户id',
            placeholder: '请输入用户id',
          },
          {
            comName: 'YkcDropdown',
            key: 'type',
            label: '筛选维度',
            clearable: false,
            data: [...this.dictionary],
          },
        ];
      },
    },
    methods: {
      /** 根据条件查询数据 */
      searchTableList() {
        dataStatisticsServe
          .userMonthChargingList({
            ...this.pageInfo,
            ...this.searchParams,
          })
          .then(res => {
            this.tableData = res.records;
            this.pageInfo.total = res.total || 0;
          });
      },
      /**
       * @desc 导出文件 - 用户月充电信息统计列表
       * */
      doExportFile() {
        offlineExport(
          {
            downloadType: 'user_month_charging_statistics',
            jsonNode: {
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },
      /**
       * @desc 点击页面左上角按钮 callback
       * */
      handlePageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
      },
      /**
       * @desc 点击查询按钮
       * */
      handleSearchConfirm(form) {
        this.pageInfo.current = 1;
        Object.assign(this.searchParams, form);
        this.searchTableList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        const date = new Date();
        this.searchParams.queryDate = `${date.getFullYear()}`; // 默认当前年份
        console.log('---queryDate', this.searchParams.queryDate);

        this.searchParams.type = 'ELECTRICAL';
        Object.assign(this.searchParams, form);
      },
      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.searchTableList();
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.searchTableList();
      },
    },
  };
</script>
<style lang="scss" scoped></style>
